import { Batch, BatchStatus } from "@wingspanhq/wingspan-api-sdk";

type Args = {
  batch?: Batch;
  /** `BatchSummary.progress.failed`. */
  failedCount?: number;
};

/**
 * v1 read `statistics.itemsFailed` off the batch; v3 keeps the counts in the
 * batch summary, so the caller passes the failed count in.
 */
export const selectorIsImportBatchFullyImported = (args: Args): boolean =>
  args.batch?.status === BatchStatus.COMPLETED && !args.failedCount;
